import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';

import { epicDependencies } from '../store';

import { NewRelicService } from './new-relic.service';

function getAgent(): BrowserAgent | null {
    /* this should be as out-of-the-way as possible. so, use epicDependencies */
    // TODO FIXME. this can be done better
    const newRelicService =
        epicDependencies.injector.get<NewRelicService>(NewRelicService);
    return newRelicService.agent;
}

export function addPageAction(name: string, attributes?: object): void {
    const finalName = `cmps.${name}`;
    const finalAttrs: any = {};
    Object.entries(attributes ?? {}).forEach(([k, v]) => {
        if (k?.trim()?.length > 0) {
            finalAttrs[`cmps.${k}`] = v;
        }
    });
    try {
        getAgent()?.addPageAction(finalName, finalAttrs);
    } catch {
        console.warn('addPageAction error');
    }
}
